export default "__VITE_ASSET__B3c_KF$k__"